import { copyFor } from '../../utils/copy'

/**
 * Where the customer is, in eight or nine ticks.
 *
 * **The count is the reassurance.** A form with no visible end is a form people abandon
 * halfway, and the one this replaces showed two steps holding twelve questions — honest
 * about its length and dishonest about its size. Nine short screens read as less work
 * than two long ones, but only if the customer can see there are nine.
 *
 * Bars rather than numbered circles: eight numbered circles and their connecting lines
 * are twenty-three shapes on a 360px phone, and the numbers are not the information. How
 * far along, and how much is left, is.
 *
 * The current step is the only one named. Naming all eight would put a row of small grey
 * words above a screen whose entire premise is having nothing extra on it.
 */
export default function StepTrail({ steps, index }) {
  const copy = copyFor(steps[index])

  return (
    <div className="mt-4">
      <ol className="flex items-center gap-1" aria-label="Hakbang">
        {steps.map((step, position) => (
          <li
            key={step}
            aria-current={position === index ? 'step' : undefined}
            className="flex-1"
          >
            {/* The label is carried by the heading below, so this is decoration to a
                screen reader and its own list item to a pointer. */}
            <span className="sr-only">{copyFor(step).short}</span>
            <span
              aria-hidden="true"
              className={`block h-1 rounded-[1px] transition-colors duration-settle ease-out ${
                position < index ? 'bg-brand/40' : position === index ? 'bg-brand' : 'bg-hairline'
              }`}
            />
          </li>
        ))}
      </ol>

      <p className="mt-2 text-label font-semibold uppercase text-ink-3">
        {index + 1} sa {steps.length} · {copy.short}
      </p>
    </div>
  )
}
